<template>
  <div class="bggray" @click="optionActive = false">
    <app-header />
    <div class="orderWrap">
      <div class="orderNav">
        <span class="cur">确认购买信息</span>
        <span class="cur">选择支付方式</span>
        <span>购买成功开通权限</span>
      </div>
      <div class="mod orderInfo" v-if="orderInfo.productPriceVo">
        <h3 class="title">订单详情<span>{{orderInfo.productPriceVo.remark}}</span></h3>
        <ul class="column6">
          <li class="title">
            <div class="liwrap">
              <div>产品名称</div>
              <div>价格/年限</div>
              <div class="child3">数量</div>
              <div class="child4">有效期</div>
              <div class="child5">优惠</div>
              <div class="child6">实付</div>
            </div>
          </li>
          <li class="mainli clearfix">
            <div class="liwrap">
              <div>
                <p>{{orderInfo.productPriceVo.productName}}</p>
                <p class="giftName" v-show="productId !== null">{{ orderInfo.describe }}</p>
              </div>
              <div class="child2" v-if="dateUnit !== 'day'">{{orderInfo.productPriceVo.oriPrice | amountUnitFormat(orderInfo.productPriceVo.month)}}</div>
              <div class="child2" v-else>{{orderInfo.productPriceVo.oriPrice | formatMonth(orderInfo.productPriceVo.month)}}</div>
              <div class="child3">*{{orderInfo.productPriceVo.month | formatQuantity(dateUnit)}}</div>
              <div class="child4">{{orderInfo.productPriceVo.powerStartDt | dateFormat("yyyy-MM-dd")}}至{{orderInfo.productPriceVo.powerEndDt | productSentPowerTime(foldedPeriod) | dateFormat("yyyy-MM-dd")}}
              </div>

              <div class="child5">￥{{orderInfo.productPriceVo.curPrice | twinPointAmountFormat(orderInfo.productPriceVo.oriPrice)}}元</div>
              <div class="child6">￥{{orderInfo.productPriceVo.curPrice}}元</div>
            </div>

            <div class="licheckbox">
              <span v-show="orderType == 2">我同意将现有大智慧低版本剩余期限按实际价值折算，合计{{foldedPeriod}}天累加至新产品有效期内</span><a class="licheckbox-btn-more" @click="showZQ=!showZQ" v-show="orderType == 2">{{showZQ?'收起明细':'展开明细'}}</a>
              <span v-show="orderType == 1">我同意将现有大智慧低版本剩余期限按实际价值折算后进行补差升级</span><a class="licheckbox-btn-more" @click="showCE=!showCE" v-show="orderType == 1">{{showCE?'收起明细':'展开明细'}}</a>

              <!-- 权限并行提示 -->
              <!-- 低买高 -->
              <div class="qxWarning qxOK" id="qxWarning" v-show="showZQ">
                <h5>【温馨提示】</h5>
                <p>为了购买新版本的大智慧，您需要将现有低版本大智慧的剩余期限按实际价值进行折算，并累计至新产品的有效期中。现有产品如下：</p>
                <ul>
                  <div
                    v-for="item in discountList"
                    :key="item.productId"
                  >
                    <li>{{ item.productName }} <span class="fr">+{{item.foldPeriodDayLength}}天</span></li>
                  </div>  
                  <li class="total">合计可折期限 <span class="fr">当前购买产品&nbsp;&nbsp;&nbsp;&nbsp;+{{foldedPeriod}}天</span></li>
                </ul>
              </div>
              
            </div>
          </li>
          <li class="subli" v-if="orderInfo.productPriceVo.subProductPriceVos">
            <div v-for="subItem in orderInfo.productPriceVo.subProductPriceVos" :key="subItem.month" class="liwrap">
              <div>{{subItem.productName}}</div>
              <div>{{subItem.oriPrice | amountUnitFormat(subItem.month)}}</div>
              <div class="child3">*{{subItem.month}}个月</div>
              <div class="child4">{{subItem.powerStartDt | dateFormat("yyyy-MM-dd")}}至{{subItem.powerEndDt | dateFormat("yyyy-MM-dd")}}</div>
              <div class="child5">¥ {{subItem.curPrice | twinPointAmountFormat(subItem.oriPrice)}}</div>
              <div class="child6">¥ {{subItem.curPrice}}</div>
            </div>
          </li>
        </ul>
        <div class="totalLine">
          <p class="note" v-show="month === 1 && dateUnit === 'month'">*该月卡为特惠体验产品，仅可购买一次，且不支持折换等其他优惠活动，敬请谅解</p>
          <p class="note" v-show="(month === 7 && dateUnit === 'day') || (month === 14 && dateUnit === 'day')">*该周卡/双周卡为特惠体验产品，仅可选择其一购买一次，且不支持折换等其他优惠活动，敬请谅解</p>
          <!-- <p class="note" v-show="yjtText">*大智慧金融信息终端月卡/双周卡/周卡仅限购买体验一次；</p> -->
          <p class="note" v-if="productId == 3052 || productId == 3053">*到期前续费该PC产品可享受老客户优惠，不与其他活动叠加享受，题材王为手机版功能不参与老用户续费优惠</p>
          <p class="note" v-else-if="productId == 3047 || productId == 3048 || productId == 3049 || productId == 3050">*到期前续费该PC产品可享受老客户优惠，不与其他活动叠加享受，沪深level2手机版不参与老用户续费优惠</p>
          <p class="note" v-else-if="productId == 3028 || productId == 3041 || productId == 3042 || productId == 3046">*本产品中的移动指标将单独计算使用期限，已经购买过移动相关指标的客户不可与本礼包中包含的移动指标叠加使用</p>
          <p class="note" v-else-if="oyb">*每个大智慧账号、每个支付账号，限购买一次；同支付账号购买多次，第二次起软件使用时长为7天</p>
          <p class="note" v-else-if="!(productId == 335 || productId == 197)">*到期前续费该产品可享受老客户优惠，不与其他活动叠加享受</p>
          <p class="voucherText" v-show="voucherCode!=0">*{{voucherMsg}}</p>
          <div class="discount-text" v-show="showCE">
            <p v-for="text in discountList" :key="text.orderId"><strong style="color: #D07D00">您的《{{text.productName}}》可折换期限{{text.remainLength}}个月，价值{{text.convertMoney}}元。</strong><em>¥ -{{text.convertMoney}}</em><em>¥ -{{text.convertMoney}}</em></p>
          </div>

          <!-- 高买低 -->
          <!-- <div class="qxWarning qxAlert" v-show="showQXNOCan">
            <p><strong>系统检测到您已拥有其他版本大智慧，本产品不可购买，如有疑问可联系客服。</strong></p>
          </div> -->
          <!-- 高买低暂存 -->
          <div class="qxWarning qxAlert" v-show="stopNotice">
            <p><strong>系统检测到您已拥有其他版本大智慧，如继续购买该产品将优先消耗高版本大智慧产品，该产品有效期将为您预存在“我的产品”中。</strong></p>
          </div>

          <div class="subtotal">
            <div>小计</div>
            <div>共{{productNum}}件</div>
            <div>¥ {{orderInfo.productPriceVo.curPrice | getDisCountMoney(orderInfo.productPriceVo.oriPrice,subCurPrice,subOriPrice,convertMoneyEnd)}}</div>
            <div>¥ {{orderInfo.productPriceVo.curPrice | getPayMoneyTotal(subCurPrice,convertMoneyEnd)}}</div>
          </div>
          <!-- <div class="discount-money">
            <div class="note-r" v-if="!orderInfo.paidMoney">
              <p>
                <span>已优惠：</span>
                <em>{{(orderInfo.payMoney- orderInfo.servePrice )}} 元</em>
              </p>
              <p class="totalMoney">
                <span>支付金额总计：</span>
                <strong>{{orderInfo.payMoney}}</strong>
                <em>元</em>
              </p>
            </div>
            <div class="note-r" v-else>
              <p class="totalMoney">
                <span>剩余待支付金额：</span>
                <strong>{{orderInfo.payMoney - orderInfo.paidMoney}}</strong>
                <em>元</em>
              </p>
            </div>
          </div> -->
        </div>
      </div>
      <div class="mod">
        <h3 class="title">用户信息</h3>
        <ul class="dispatch-list">
          <li>账号：{{userName}}</li>
          <li>
            发票：电子发票
            <span v-if="orderInfo.invoiceTitleType === 1">个人</span>
            <span v-if="orderInfo.invoiceTitleType === 2">单位</span>
          </li>
          <li v-if="!oyb">账户余额：￥{{amount}}元（大额充值后10个工作日内不购买产品账户余额将原路返还。)<span class="icon" @click="isRecordPop = true">?</span></li>
        </ul>
      </div>
      <div class="mod pr">
        <h3 class="title">支付方式</h3>
        <div class="nav-pay clearfix">
          <div v-if="oyb">
            <span @click="selectPayModeOuter(11,0)" :class="{cur : payIndex == 0}">支付宝/微信</span>
          </div>
          <div v-else>
            <span @click="selectPayModeOuter(11,0)" :class="{cur : payIndex == 0}">支付宝/微信/银联/余额支付</span>
            <span @click="selectPayModeOuter(27,1)" :class="{cur : payIndex == 1}">储蓄卡支付</span>
            <span @click="selectPayModeOuter(26,2)" :class="{cur : payIndex == 2}" v-if="orderInfo.payMoney > 1000">其他网上银行</span>
            <div class="select">
              <div class="selected" @click.stop="payActive = !payActive" v-if="orderInfo.payMoney !== 1">
                <span :class="{cur : payIndex === 3 || payIndex === 4}">{{ selectedText }}</span>
                <i :class="{selectBtnUp : payActive == true}" class="icon-selectBtn"></i>
              </div>
              <ul class="optionList" v-show="payActive == true">
               <!-- <li @click="selectMore($event,7,3)" :class="{cur : payIndex == 3}" v-if="orderInfo.payMoney !== 1">快钱支付</li> -->
                <li @click="selectMore($event,3,4)" :class="{cur : payIndex == 4}" v-if="orderInfo.payMoney > 1000" v-show="productId !== 3028">银行转账</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="pay-con">
          <div class="bank-list" v-show="payIndex === 0">
            <template v-for="(item, index) in mainPay">
              <span
                :key="item.id"
                :class="{cur: index === bankIndex}"
                @click="selectPayModeInner(item.payMode, index)"
                v-if="index === 0 && !oyb"
                class="balance-icon">
                <img :src="require('@/assets/images/bank/' + item.imgName)" />
                <p>账户余额</p>
                <i>￥{{amount}}</i>
              </span>
              <span
                :key="item.id"
                :class="{cur: index === bankIndex}"
                @click="selectPayModeInner(item.payMode, index)"
                v-else-if="item.payMode === 1111 && !oyb"
                class="balance-icon recharge-icon">
                <img :src="require('@/assets/images/bank/' + item.imgName)" />
                <p>大额充值</p>
              </span>
              <span
                :key="item.id"
                :class="{cur: index === bankIndex}"
                @click="selectPayModeInner(item.payMode, index)"
                v-else-if="index === 3 && !oyb"
              >
                <img :src="require('@/assets/images/bank/' + item.imgName)" />
              </span>
              <span
                :key="item.id"
                :class="{cur: index === bankIndex}"
                @click="selectPayModeInner(item.payMode, index)"
                v-else-if="(index !== 0 && item.payMode !== 1111 && index !== 3 && item.payMode !== 42) || (item.payMode === 42 && showWeComPay)"
              >
                <img :src="require('@/assets/images/bank/' + item.imgName)" />
              </span>
            </template>
          </div>
          <!-- 储蓄卡银行列表 -->
          <div class="bank-list" v-show="payIndex === 1">
            <span
              v-for="(item, index) in unionPayB2C"
              :key="item.id"
              :class="{cur: index === bankIndex}"
              @click="selectBank(item.bankCode, index)"
            >
              <img :src="require('@/assets/images/bank/' + item.imgName)" />
            </span>
          </div>
          <div class="unionPayOnline" v-show="payIndex === 2">
            <div class="bank-list">
              <span
                v-for="(item, index) in unionPayOnline"
                :key="item.id"
                :class="{cur: index === bankIndex}"
                @click="bankIndex = index"
              >
                <img :src="require('@/assets/images/bank/' + item.imgName)" />
              </span>
            </div>
            <div class="unionPayOnline-r" >
              <p>如果您网上银行的单次支付限额足以支付上述费用，请直接点击下面的支付按钮 如果无法单次完成支付，请输入本次想要支付的金额 (最低{{orderInfo.minMoney}}元，最高{{orderInfo.maxMoney}}元)</p>
              <input type="text" oninput="value=value.replace(/[^\d^\.]+/g, '').replace(/^0+(\d)/, '$1').replace(/^\./, '0.').match(/^\d*(\.?\d{0,1})/g)" v-model="payMoney" />元
            </div>
          </div>
          <!-- 快钱银行列表 -->
          <div class="bank-list" v-show="payIndex === 3">
            <span
              v-for="(item, index) in bill99Pay"
              :key="item.id"
              :class="{cur: index === bankIndex}"
              @click="selectBank(item.bankCode, index)"
            >
              <img :src="require('@/assets/images/bank/' + item.imgName)" />
            </span>
          </div>
          <div class="bank-list" v-show="payIndex === 4">
            <span
              v-for="(item, index) in transPay"
              :key="item.id"
              :class="{cur: index === bankIndex}"
              @click="selectBank(item.bankCode, index)"
            >
              <img :src="require('@/assets/images/bank/' + item.imgName)" />
            </span>
          </div>
        </div>
        <p class="pay-info">
          如遇到支付问题，可随时拨打
          <em>021-20219999</em>，客服将第一时间帮你解决
        </p>
        <a class="btn-normal" @click="orderPay">{{this.payMode === 1111 ? '去充值' : '去支付'}}</a>
      </div>
    </div>
    <popRecord :isPop="isRecordPop" :recordList="recordList" @close="popClose"/>
    <app-footer />
  </div>
</template>
<script>
import AppHeader from "@/components/common/AppHeader.vue";
import AppFooter from "@/components/common/AppFooter.vue";
import payData from "@/assets/paybank.json";
import PopRecord from '../../components/order/PopRecord.vue';
export default {
  data() {
    return {
      orderId: this.$route.params.orderId,
      payMoney: "",
      oyb: false,
      yjtText: false,
      payMode: 35, //默认余额支付
      bankCode: "",
      orderInfo: {},
      payActive: false,
      payIndex: 0,
      bankIndex: 0,
      selectedText: "更多",
      mainPay: payData.mainPay,
      unionPayB2C: payData.unionPayB2C,
      unionPayOnline: payData.unionPayOnline,
      bill99Pay: payData.bill99Pay,
      transPay: payData.transPay,
      orderPayAble: true,
      productId: '',
      rechargeInfo: {},
      userName: "",
      amount: 0,
      discountList: [],
      isDiscount: false,
      // discountText: false,
      convertMoney: 0,
      voucherCode:0,
      voucherMsg:"",
      isRecordPop: false,
      recordList: [],
      orderType:0,
      month: '',
      dateUnit: '',
      foldedPeriod: 0,
      showZQ: false,
      showCE: false,
      // showQXCan:true,
      // showQXNOCan:false,
      //isAlert:false,
      showQXConfirm:false,
      stopNotice: false,
      showWeComPay: false,

    };
  },
  created() {
    this.getData();
    this.getUserAcountDate();
    this.getRecord()
  },
  computed: {
    convertMoneyEnd () {
      return this.orderType == 1 ? this.convertMoney : 0
    }
  },
  methods: {
    getData() {
      this.$get("/order/pay?id=" + this.orderId)
        .then(response => {
          if (response.code === 0) {
            this.orderInfo = response.data;
            this.productId = response.data.productId;
            this.orderType = response.data.orderType;
            this.month = response.data.monthCount;
            this.dateUnit = response.data.dateUnit;
            // this.foldedPeriod = response.data.foldedPeriodDayNum;
            var powerCheckCode = response.data.powerCheckCode;
            if(response.data.showWeComPay){
              this.showWeComPay = response.data.showWeComPay;
            }
            if(powerCheckCode == 12 || powerCheckCode == 2){
              this.stopNotice = true;
            }
            console.log(!response.data.dateUnit)
            if(response.data.monthCount === 1 && response.data.payMoney === 1){
              this.oyb = true;
            }
            if(response.data.productId === 335 && (response.data.monthCount === 1 || response.data.monthCount === 7 || response.data.monthCount === 14)){
              this.yjtText = true;
            }else{
              this.yjtText = false;
            }
            this.getPrice()
            if (this.orderInfo.paidMoney > 0) {
              this.selectPayModeOuter(26,2);
            }

            if(this.orderType === 2 || this.orderType === 1){
              var params = {
              id: this.productId,
              month: response.data.monthCount
              };
              this.$get("/order/orderUpgradeCalc", params)
              .then(response => {
                if (response.code === 0) {
                  this.discountList = response.data.orderVoucherGroupVoList;
                  this.foldedPeriod = response.data.foldedPeriod;
                  // this.discountList.length > 0 && (this.showZQ == true);
                  this.convertMoney = this.discountList.reduce((pre, cur) =>{
                    return pre + cur.convertMoney
                  }, 0)
                } else {
                  this.voucherCode = response.code;
                  this.voucherMsg = response.msg
                  return
                }
              })
            }
          } else if (!(response.code === 100 || response.code === 9999)) {
            this.$global.alert(response.msg);
          }
        })
        .catch(err => {
          this.$global.alertAndGoHistory("网络异常，请稍后重试。");
        });
    },
    getUserAcountDate(){
      this.$get("/recharge/detail")
      .then(response => {
          if (response.code === 0) {
            this.rechargeInfo = response.data;
            this.userName = response.data.userName;
            this.amount = response.data.amount
          } else if (!(response.code === 100 || response.code === 9999)) {
            this.$global.alertAndGoHistory(response.msg);
          }
        })
        .catch(err =>{
          this.$global.alertAndGoHistory("网络异常，请稍后重试。");
        });
    },
    selectPayModeOuter(payMode, payIndex) {
      if (payMode == 27 || payMode == 7) {
        this.bankCode = "ABC";
      }
      if (payMode == 3) {
        this.bankCode = "ICBC";
      }
      this.payActive = false;
      this.payMode = payMode;
      this.payIndex = payIndex;
      this.bankIndex = 0;
    },
    selectBank(bankCode, bankIndex) {
      this.bankCode = bankCode;
      this.bankIndex = bankIndex;
    },
    selectPayModeInner(payMode, bankIndex) {
      if (payMode == 26) {
        this.payMoney = '';
      }
      this.payMode = payMode;
      this.bankIndex = bankIndex;
    },
    selectMore(e, payMode, payIndex) {
      this.payActive = false;
      this.selectedText = e.target.innerText;
      this.selectPayModeOuter(payMode, payIndex);
    },
    rechargeAmount(orderId){
      this.$router.push("/order/recharge/"+orderId);
    },
    orderPay() {
      if (!this.payMode) {
        this.$alert("请选择您的支付方式", "提示", {
          confirmButtonText: "确定"
        });
        return false;
      }
      if (this.payMode === 1111) {
        this.$router.push("/order/recharge/"+ this.orderId);
        return false
      }
      if (this.payMode === 3) {
        // 跳转转账页面
        this.$router.push("/pay/trans/" + this.orderId+"/1/"+this.bankCode);
        return false;
      }
      if (this.payMode === 23 || this.payMode === 42) {
        if (this.orderInfo.paidMoney) {
          this.payMode = 26;
        } else {
          // 跳转二维码支付页面
          this.$router.push("/pay/qrcode/" + this.orderId + "/" + this.payMode);
          return false;
        }
      }
      // web支付页面
      if (!this.orderPayAble) {
        return false;
      }
      var params = {
        id: this.orderId,
        payMode: this.payMode
      };
      if (this.payMode == 27 || this.payMode == 7) {
        params.bankCode = this.bankCode;
      }
      if (this.payMoney) {
        params.payMoney = this.payMoney;
      }
      if(this.payMode == 35 && this.orderInfo.payMoney == 1){
        this.payMode = 11;
        params.payMode = 11;
      }
      this.orderPayAble = false;
      this.$get("/pay/web", params)
        .then(response => {
          if (response.code === 0) {
            if(this.payMode==35){
             this.$router.push("/order/detail/" + this.orderId);
             return false;
            }
            window.location.href = response.data;
          } else if (response.code != 100) {
            this.$global.alert(response.msg);
          }
          this.orderPayAble = true;
        })
        .catch(err => {
          this.orderPayAble = true;
          this.$global.alertError();
        });
    },
    getPrice () {
      if (this.orderInfo.productPriceVo.hasOwnProperty("subProductPriceVos")) {
        this.subCurPrice = this.orderInfo.productPriceVo.subProductPriceVos.reduce((pre, cur) =>{
          return pre + cur.curPrice
        }, 0)
        this.subOriPrice = this.orderInfo.productPriceVo.subProductPriceVos.reduce((pre, cur) =>{
          return pre + cur.oriPrice
        }, 0)
        this.productNum = 1 + this.orderInfo.productPriceVo.subProductPriceVos.length
      } else {
        this.subCurPrice = 0
        this.subOriPrice = 0
        this.productNum = 1
      }
    },
    popClose (val) {
      this.isRecordPop = val
    },
    getRecord(){
      this.$get("recharge/history")
      .then(response => {
          if (response.code === 0) {
            this.recordList = response.data;
          } else if (!(response.code === 100 || response.code === 9999)) {
            this.$global.alertAndGoHistory(response.msg);
          }
        })
        .catch(err =>{
          this.$global.alertAndGoHistory("网络异常，请稍后重试。");
        });
    },
  },
  filters: {
    formatMonth (price, month) {
      if (month === 1) {
        return price + '元/' + month + '月'
      } else if (month === 7) {
        return price + '元/7天'
      } else if (month === 14) {
        return price + '元/14天'
      }
    },
    formatQuantity (month, dateUnit) {
      if(dateUnit === 'day') {
        if (month === 1) {
          return month + '个月'
        } else if (month === 7) {
          return '7天'
        } else if (month === 14) {
          return '14天'
        }
      } else {
         return month + '个月'
      }
    },
    productSentPowerTime (val1,val2) {
      return val1 + val2*24*60*60*1000
    }
  },
  components: {
    AppHeader,
    AppFooter,
    PopRecord
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/scss/order.scss";
.orderInfo>ul>li:nth-child(2)>div .giftName{width: 250px;}
.icon-checked {
  background-image: url(~@/assets/images/icon/right.png);
  background-size: 14px auto;
  width: 20px;
  height: 20px;
  margin-right: 8px;
  background-color: #166eff;
  cursor: pointer;
}
.orderInfo {
  .column4 {
    li {
      > div {
        &:first-child {
          width: 280px;
        }
        &:nth-child(2) {
          width: 230px;
        }
        &:nth-child(3) {
          width: 270px;
        }
      }
      &:nth-child(2) {
        > div {
          &:last-child {
            @include fc(20px, #222);
          }
        }
      }
    }
  }
}
.dispatch-list {
  li {
    @include fc(16px, #000);
    margin-bottom: 12px;
    &:nth-child(1) {
      float: left;
      width: 300px;
    }
    .icon{
      border: 1px solid #666666;
      width: 18px;
      height: 18px;
      font-size: 15px;
      color: #666666;
      text-align: center;
      line-height: 18px;
      display: inline-block;
      margin-left: 10px;
      border-radius: 50%;
      cursor: pointer;
    }
  }
}
.nav-pay {
  span {
    padding: 0 16px;
    @include line-height(40px);
    border: 1px solid #e5e5e5;
    border-right: 0;
    background: #fff;
    float: left;
    box-sizing: border-box;
    cursor: pointer;
    &.cur {
      background: #fbfbfb;
      border-top: 2px solid #166fff;
      border-bottom: 1px solid #fbfbfb;
    }
  }
  .select {
    float: left;
    position: relative;
    .selected {
      position: relative;
      .icon-selectBtn {
        border-left: 0;
        height: 40px;
      }
      span {
        width: 120px;
        border-right: 1px solid #e5e5e5;
      }
    }
    .optionList {
      width: 118px;
      top: 40px;
      li {
        text-indent: 0;
        text-align: center;
      }
    }
  }
}
.pay-con {
  margin: -1px 0 70px 0;
  width: 100%;
  box-sizing: border-box;
  background: rgba(216, 216, 216, 0.1);
  padding: 30px 15px;
  border: 1px solid #e5e5e5;
  > .bank-list {
    &:first-child {
      img {
        height: 58px;
      }
    }
  }
  .bank-list {
    & > span {
      background: #ffffff;
      border: 1px solid #d6d6d6;
      border-radius: 1.96px;
      @include wh(167px, 60px);
      text-align: center;
      display: inline-block;
      margin: 0 15px 15px 0;
      line-height: 60px;
      &:nth-child(5n) {
        margin-right: 0;
      }
      cursor: pointer;
      img {
        vertical-align: middle;
      }
      &.cur {
        border: 1px solid #166fff;
        position: relative;
        &:after {
          content: "";
          display: inline-block;
          @extend .icon-checked;
          background-repeat: no-repeat;
          background-position: center center;
          position: absolute;
          right: -1px;
          bottom: -1px;
          margin-right: 0;
        }
      }
      &.balance-icon{
        text-align: left;
        position: relative;
        img{
          width: auto;
          height: auto;
          margin-left: 25px;
        }
        p{
          position: absolute;
          left: 70px;
          top: -6px;
          font-size: 14px;
          color: #394144;
        }
        i{
          position: absolute;
          left: 70px;
          top: 13px;
          font-size: 12px;
          color: #101010;
        }
      }
      &.recharge-icon{
        display: block;
        margin-bottom: 0;
        p{
          top: 2px;
          left: 60px;
        }
      }
    }
  }
  .unionPayOnline {
    .bank-list {
      float: left;
    }
    .unionPayOnline-r {
      margin-left: 400px;
      border-left: 1px solid #dbdbdb;
      padding: 0px 30px 5px;
      p {
        @include fc(14px, #666);
        line-height: 22px;
        margin-bottom: 10px;
      }
      input {
        border: 1px solid #dbdbdb;
        line-height: 24px;
        width: 110px;
        margin-right: 5px;
        padding-left: 10px;
      }
    }
  }
}
.pay-info {
  @include fc(14px, #666);
  padding-bottom: 45px;
  em {
    color: #166fff;
  }
}
.btn-normal {
  bottom: 40px;
    &:hover{
    background: #1460db;
  }
}
.qxWarning{
  background:#fff;
  padding:16px 20px 85px;
  font-size:15px;
  color:#222;
  //margin-top:20px;
  border-radius:6px;
  border:1px solid #166FFF;
  position:absolute;
  box-shadow: 0px 6px 10px 0px rgba(114, 114, 114, 0.25);
  left:0;right:0;
  line-height:22px;
  &.qxAlert{
    position:static;
    box-shadow:none;
    border:0;background:#fdf9f2;
    padding:20px 0;
    margin-top:10px;
  }
  &.qxOK{
    //padding-bottom:85px;
    overflow:hidden;
    &:after{
      content:'';position:absolute;right:40px;bottom:10px;background:url(~@/assets/images/icon/icon-agree.png) no-repeat 0 0;background-size:100% auto;width:90px;height:72px;
    }
  }
  .fr{
    float:right;
  }
  h5{
    text-align:center;
    font-size:16px;
    margin-bottom:10px;
  }
  p{
    strong{
      display:block;
      color:#DE8704;text-align:center;font-weight:normal;
    }
  }
  ul{
    margin-top:15px;
    li{
      border-bottom:1px solid #FFF0D9;
      line-height:32px;
      padding:0 20px;
      &.total{
        font-weight:bold;
        color:#D07D00;
      }
    }
  }
}
.orderInfo>ul.column6 li .liwrap div.child4{
  .qx-discount{
    color:#DE8704;
    margin:0 -20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/order/OrderPay.vue